export interface AuthSession {
  sub: string
  email: string
  name?: string
  picture?: string
}

export async function fetchSession(): Promise<AuthSession | null> {
  const res = await fetch('/auth/me', { credentials: 'same-origin' })
  if (res.status === 401) return null
  if (!res.ok) throw new Error(`/auth/me failed: ${res.status}`)
  return (await res.json()) as AuthSession
}

export async function logout(): Promise<void> {
  await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' })
}

export function loginWithGoogle(): void {
  window.location.href = '/auth/google'
}

/** Portal landing access — which top tabs / label sub-tabs this user sees. */
export interface PortalAccess {
  everyone: boolean
  labels: string[]
  /** "for Brand Intelligence Consulting" — 최상위 카테고리(레이블 아님).
   *  everyone 과 달리 **기본이 false** 다: 없으면 안 준 것이지 준 것이 아니다. */
  bic: boolean
  /** 전사 직원 — Salesforce Products·확인서 발송 접근. bic 처럼 **기본이 false** 이고,
   *  bic 와 달리 어드민도 바이패스하지 않는다. */
  employee: boolean
}

export async function fetchAccess(): Promise<PortalAccess> {
  const res = await fetch('/api/me/access', { credentials: 'same-origin' })
  // 조회 실패 시 bic·employee 는 열지 않는다 — 서버 게이트가 어차피 403 이라 열어봐야 빈 화면이다.
  if (!res.ok) return { everyone: true, labels: [], bic: false, employee: false }
  const data = (await res.json()) as Partial<PortalAccess>
  return {
    everyone: data.everyone !== false,
    labels: Array.isArray(data.labels) ? data.labels : [],
    bic: data.bic === true,
    employee: data.employee === true,
  }
}
